import React, { FC, Suspense, useLayoutEffect } from 'react';
import { StudyNameComponent } from 'src/components/studyName/studyName.component';
import { useStudy } from 'src/helpers/hooks/useStudy';
import { StudyInfoPageSection as StudyInfoPageSectionEnum, StudyRoleClaimValue } from 'src/services/api/api-client';
import { StudyInfoPageLayout, StudyInfoPageSection } from './layoutComponents/StudyInfoPageLayout';
import {
  PatientsSection,
  PrimaryObjectiveSection,
  RecruitmentProgressSection,
  StudyFilesSection,
  StudyNoteSection,
  StudyPeriodSection,
  UsersSection,
} from './sections';
import { useHasStudyClaims } from 'src/helpers/auth/auth-helper';
import { useNavigate } from 'react-router';
import { navigateToRoute } from 'src/navigation/routes';

export const StudyInfoPage = () => {
  const study = useStudy();
  const { hasStudyClaim } = useHasStudyClaims();
  const navigate = useNavigate();

  useLayoutEffect(() => {
    if (!hasStudyClaim(StudyRoleClaimValue.StudyInfoPageView)) navigate(navigateToRoute.dashboard(study!.id));
  }, [hasStudyClaim, navigate, study]);

  return (
    <Suspense>
      <StudyInfoPageLayout testId={'study-info-page'} isLoading={false}>
        <StudyInfoPageLayout.Header>
          <StudyNameComponent />
        </StudyInfoPageLayout.Header>
        <StudyInfoPageLayout.Columns>
          {study?.infoPageConfiguration?.sections.map((col, i) => (
            <StudyInfoPageLayout.Columns.Column key={i} colored={i % 2 !== 0}>
              {col.map((section, idx) => (
                <React.Fragment key={idx}>{StudyInfoSectionResolver[section]}</React.Fragment>
              ))}
            </StudyInfoPageLayout.Columns.Column>
          ))}
        </StudyInfoPageLayout.Columns>
      </StudyInfoPageLayout>
    </Suspense>
  );
};

const NotImplemented: FC<{ title: string }> = ({ title }) => (
  <StudyInfoPageSection title={title}>
    <div>{'Not implemented yet'}</div>
  </StudyInfoPageSection>
);

const StudyInfoSectionResolver: Record<StudyInfoPageSectionEnum, JSX.Element> = {
  [StudyInfoPageSectionEnum.StudyPeriod]: <StudyPeriodSection />,
  [StudyInfoPageSectionEnum.Patients]: <PatientsSection />,
  [StudyInfoPageSectionEnum.Records]: <NotImplemented title={'Records'} />,
  [StudyInfoPageSectionEnum.Attachments]: <StudyFilesSection />,
  [StudyInfoPageSectionEnum.Notes]: <StudyNoteSection />,
  [StudyInfoPageSectionEnum.Users]: <UsersSection />,
  [StudyInfoPageSectionEnum.RecruitmentProgress]: <RecruitmentProgressSection />,
  [StudyInfoPageSectionEnum.PrimaryObjective]: <PrimaryObjectiveSection />,
};
